/* Sui Story — sliders & carousels.
   Hero slider (crossfade)        : [data-slider] > [data-slider-track] > [data-slide]
                                    optional [data-slider-dots] [data-slider-prev] [data-slider-next]
                                    attrs: data-autoplay="true" data-interval="5500"
   Horizontal carousel (snap)     : [data-carousel] (the scroller)
                                    [data-carousel-prev] [data-carousel-next] [data-carousel-dots]
   Re-inits on 'suistory:page:init'. Honours prefers-reduced-motion. */
(function () {
  var S = (window.SuiStory = window.SuiStory || {});
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Hero crossfade slider ---------- */
  function initSliders(scope) {
    (scope || document).querySelectorAll('[data-slider]').forEach(function (root) {
      if (root.__sliderInit) return;
      root.__sliderInit = true;

      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
      if (slides.length === 0) return;

      var dotsWrap = root.querySelector('[data-slider-dots]');
      var prev = root.querySelector('[data-slider-prev]');
      var next = root.querySelector('[data-slider-next]');
      var i = 0, timer = null;
      var auto = root.getAttribute('data-autoplay') === 'true' && !reduce && slides.length > 1;
      var interval = parseInt(root.getAttribute('data-interval'), 10) || 5500;
      var dots = [];

      if (dotsWrap && slides.length > 1) {
        dotsWrap.innerHTML = '';
        slides.forEach(function (_, n) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'slider__dot';
          b.setAttribute('aria-label', 'Go to slide ' + (n + 1));
          b.addEventListener('click', function () { go(n); restart(); });
          dotsWrap.appendChild(b);
          dots.push(b);
        });
      }

      function paint() {
        slides.forEach(function (s, n) {
          var on = n === i;
          s.classList.toggle('is-active', on);
          s.setAttribute('aria-hidden', on ? 'false' : 'true');
        });
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      }
      function go(n) { i = (n + slides.length) % slides.length; paint(); }
      function restart() { if (!auto) return; clearInterval(timer); timer = setInterval(function () { go(i + 1); }, interval); }

      if (prev) prev.addEventListener('click', function () { go(i - 1); restart(); });
      if (next) next.addEventListener('click', function () { go(i + 1); restart(); });
      if (slides.length < 2) { if (prev) prev.hidden = true; if (next) next.hidden = true; }

      root.addEventListener('mouseenter', function () { clearInterval(timer); });
      root.addEventListener('mouseleave', restart);

      // Touch swipe (mobile): one swipe = exactly one slide, both directions.
      // Direction-locked on the first move so vertical gestures still scroll the page.
      if (slides.length > 1) {
        var sx = 0, sy = 0, dx = 0, dy = 0, swiping = false, axis = null;
        var SWIPE_MIN = 40; // px of horizontal travel needed to count as a swipe
        root.addEventListener('touchstart', function (e) {
          clearInterval(timer);                       // pause autoplay while touching
          var t = e.changedTouches[0];
          sx = t.clientX; sy = t.clientY; dx = 0; dy = 0; swiping = true; axis = null;
        }, { passive: true });
        root.addEventListener('touchmove', function (e) {
          if (!swiping) return;
          var t = e.changedTouches[0];
          dx = t.clientX - sx; dy = t.clientY - sy;
          if (axis === null && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
            axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
          }
          if (axis === 'x') e.preventDefault();       // claim the horizontal swipe
        }, { passive: false });
        var endSwipe = function () {
          if (!swiping) return;
          swiping = false;
          if (axis === 'x' && Math.abs(dx) > SWIPE_MIN) {
            if (dx < 0) go(i + 1); else go(i - 1);     // left = next, right = prev — one slide only
          }
          restart();                                   // resume autoplay
        };
        root.addEventListener('touchend', endSwipe, { passive: true });
        root.addEventListener('touchcancel', endSwipe, { passive: true });
      }

      paint();
      restart();
    });
  }

  /* ---------- Horizontal scroll-snap carousel ---------- */
  function initCarousels(scope) {
    (scope || document).querySelectorAll('[data-carousel]').forEach(function (scroller) {
      if (scroller.__carouselInit) return;
      scroller.__carouselInit = true;

      var wrap = scroller.closest('[data-carousel-wrap]') || scroller.parentNode;
      var prev = wrap.querySelector('[data-carousel-prev]');
      var next = wrap.querySelector('[data-carousel-next]');
      var dotsWrap = wrap.querySelector('[data-carousel-dots]');
      var items = Array.prototype.slice.call(scroller.children);
      if (!items.length) return;

      function step() {
        var first = items[0];
        var gap = parseFloat(getComputedStyle(scroller).columnGap || getComputedStyle(scroller).gap || 0) || 0;
        return first.getBoundingClientRect().width + gap;
      }
      function scrollByDir(dir) {
        scroller.scrollBy({ left: dir * step(), behavior: reduce ? 'auto' : 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { scrollByDir(-1); });
      if (next) next.addEventListener('click', function () { scrollByDir(1); });

      var dots = [];
      if (dotsWrap) {
        dotsWrap.innerHTML = '';
        items.forEach(function (_, n) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'slider__dot';
          b.setAttribute('aria-label', 'Go to item ' + (n + 1));
          b.addEventListener('click', function () {
            scroller.scrollTo({ left: n * step(), behavior: reduce ? 'auto' : 'smooth' });
          });
          dotsWrap.appendChild(b);
          dots.push(b);
        });
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) {
              var idx = items.indexOf(en.target);
              dots.forEach(function (d, n) { d.classList.toggle('is-active', n === idx); });
            }
          });
        }, { root: scroller, threshold: 0.6 });
        items.forEach(function (it) { io.observe(it); });
      }

      function syncArrows() {
        if (!prev && !next) return;
        var max = scroller.scrollWidth - scroller.clientWidth - 2;
        if (prev) prev.toggleAttribute('disabled', scroller.scrollLeft <= 2);
        if (next) next.toggleAttribute('disabled', scroller.scrollLeft >= max);
      }
      scroller.addEventListener('scroll', function () { window.requestAnimationFrame(syncArrows); }, { passive: true });
      syncArrows();
    });
  }

  // Re-measure when a hidden tab panel becomes visible
  S.refreshSliders = function (scope) {
    (scope || document).querySelectorAll('[data-carousel]').forEach(function (s) {
      s.dispatchEvent(new Event('scroll'));
    });
  };

  function initAll(scope) { initSliders(scope); initCarousels(scope); }
  S.initSliders = initAll;
  document.addEventListener('suistory:page:init', function (e) {
    initAll(e.detail && e.detail.scope);
  });
})();
